import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeTeacherResourceFilesFields {
  name: EntryFieldTypes.Symbol
  slug?: EntryFieldTypes.Symbol
  path?: EntryFieldTypes.Symbol
  description?: EntryFieldTypes.Text
  files?: EntryFieldTypes.Array<EntryFieldTypes.AssetLink>
  domains: EntryFieldTypes.Array<
    EntryFieldTypes.Symbol<'all' | 'au' | 'ca' | 'cn' | 'in' | 'kr' | 'nz' | 'th' | 'uk' | 'us' | 'za'>
  >
}

export type TypeTeacherResourceFilesSkeleton = EntrySkeletonType<TypeTeacherResourceFilesFields, 'teacherResourceFiles'>
export type TypeTeacherResourceFiles<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeTeacherResourceFilesSkeleton,
  Modifiers,
  Locales
>

export function isTypeTeacherResourceFiles<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeTeacherResourceFiles<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'teacherResourceFiles'
}

export type TypeTeacherResourceFilesWithoutLinkResolutionResponse = TypeTeacherResourceFiles<'WITHOUT_LINK_RESOLUTION'>
export type TypeTeacherResourceFilesWithoutUnresolvableLinksResponse =
  TypeTeacherResourceFiles<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypeTeacherResourceFilesWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> =
  TypeTeacherResourceFiles<'WITH_ALL_LOCALES', Locales>
export type TypeTeacherResourceFilesWithAllLocalesAndWithoutLinkResolutionResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeTeacherResourceFiles<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypeTeacherResourceFilesWithAllLocalesAndWithoutUnresolvableLinksResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeTeacherResourceFiles<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
